module.exports = __webpack_public_path__ + "assets/img/uzieb-y-farma.f472a498.jpg";